import { Navigate, useLocation } from 'react-router-dom';

interface RedirectWithSearchProps {
  to: string;
  /** Query parameters added to (or overriding) whatever the old URL carried. */
  params?: Record<string, string>;
}

/**
 * A route alias that keeps the query string. Old paths that moved under a
 * page switch (`/spend-leakage` → `/spend?tab=leakage`) stay valid for
 * bookmarks, notification links and the calendar without every emitter
 * learning the new address.
 */
export default function RedirectWithSearch({ to, params = {} }: RedirectWithSearchProps) {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  Object.entries(params).forEach(([key, value]) => search.set(key, value));
  const query = search.toString();
  return <Navigate to={query ? `${to}?${query}` : to} replace />;
}
